<template>
  <NuxtLayout>
    <div :class="$style.root">
      <code :class="$style.code" v-if="isDev">{{ error }}</code>
      <div :class="$style.error" v-else>
        <span :class="$style.message">{{ $t('error.message') }}</span>&thinsp;
        <button @click="handleError" :class="$style.button">
          {{ $t('error.button') }}
        </button>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
const runtimeConfig = useRuntimeConfig()

const props = defineProps({
  error: Object
})

const handleError = () => clearError({ redirect: '/' })

const isDev = runtimeConfig?.public?.env === 'development'

const error = computed(() => props.error)
watch(error, (error) => {
  if (error) {
    console.error(error)
  }
})
</script>

<style module>
.root {
  flex: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
}

.code {
  font-size: 18px;
  line-height: 1;
  padding: 2em;
  background-color: #e2e2e2;
}

.error {
  composes: container--default font-size-large from global;
  text-align: center;
}

.message {}

.button {
  composes: reset-button from global;
  text-transform: lowercase;
  text-decoration-line: underline;
}
</style>
